export const env = {
  RT_CLUSTER_GRAPH_URL: process.env.RT_CLUSTER_GRAPH_URL,
  PM_GRAPH: process.env.PM_GRAPH,
  PM_VISNINGER: process.env.PM_VISNINGER,
  DIGGER_API_KEY: process.env.DIGGER_API_KEY,
  DOCKER_OBJECT_PAGE: process.env.DOCKER_OBJECT_PAGE,
  DS: process.env.DS,
};
